import dateHoursParticipantsFields from '../../../form/dateHoursParticipantsFields';
import type { Form } from '../../../../common/types/form';
import type { Documentation } from '../../../../common/types/documentation';
import { Setting } from '../../../../common/types/settings';

const groupForm = (groups: Setting[]): Form<Documentation> => {
  const groupOptions = groups.map((group) => ({ value: group.id, label: group.value }));
  return {
    key: 'groups',
    title: 'Gruppen',
    fields: [
      {
        key: 'group',
        label: 'Gruppe',
        fieldTypes: 'select',
        options: groupOptions,
      },
      ...dateHoursParticipantsFields,
    ],
  };
};

export default groupForm;
